/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateUserConfigSelfOptions,
  UpdateUserConfigSelfStatus200,
  UpdateUserConfigSelfStatus400,
  UpdateUserConfigSelfStatus404,
  UpdateUserConfigSelfStatus500,
} from '../types/UpdateUserConfigSelf'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateUserConfigSelf } from '../clients/updateUserConfigSelf'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateUserConfigSelfMutationKey = () => [{ url: '/v1/user/config/self' }] as const

export function updateUserConfigSelfMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateUserConfigSelfMutationKey()
  return mutationOptions<
    UpdateUserConfigSelfStatus200,
    ResponseErrorConfig<
      UpdateUserConfigSelfStatus400 | UpdateUserConfigSelfStatus404 | UpdateUserConfigSelfStatus500
    >,
    UpdateUserConfigSelfOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return updateUserConfigSelf({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update user configuration for the authenticated user
 * {@link /v1/user/config/self}
 */
export function useUpdateUserConfigSelf<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateUserConfigSelfStatus200,
      ResponseErrorConfig<
        | UpdateUserConfigSelfStatus400
        | UpdateUserConfigSelfStatus404
        | UpdateUserConfigSelfStatus500
      >,
      UpdateUserConfigSelfOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateUserConfigSelfMutationKey()

  const baseOptions = updateUserConfigSelfMutationOptions(config) as UseMutationOptions<
    UpdateUserConfigSelfStatus200,
    ResponseErrorConfig<
      UpdateUserConfigSelfStatus400 | UpdateUserConfigSelfStatus404 | UpdateUserConfigSelfStatus500
    >,
    UpdateUserConfigSelfOptions,
    TContext
  >

  return useMutation<
    UpdateUserConfigSelfStatus200,
    ResponseErrorConfig<
      UpdateUserConfigSelfStatus400 | UpdateUserConfigSelfStatus404 | UpdateUserConfigSelfStatus500
    >,
    UpdateUserConfigSelfOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateUserConfigSelfStatus200,
    ResponseErrorConfig<
      UpdateUserConfigSelfStatus400 | UpdateUserConfigSelfStatus404 | UpdateUserConfigSelfStatus500
    >,
    UpdateUserConfigSelfOptions,
    TContext
  >
}
